/* rsx-sticky-buy.js (2026-10-15, sticky buy bar). Drives every [data-rsb] bar printed by snippets/rsx-sticky-buy.liquid.
   - When it shows: product page = once the main Add to cart has scrolled above the screen (v2 rule; off_screen = the round-3
     rule); homepage = once the hero's Add to cart (tablets: the hero) is above the screen and the "Choose your bottle." form is
     off screen; collections = once the chosen card's buy area, or with no pick the whole grid, is above the screen. Never
     while the footer is on screen (no footer link is ever under the bar). The cart drawer, the menu, search and the welcome
     popup hide it through CSS.
   - What it shows: product page = the page's product (quantity and Subscribe & save follow the main form); homepage = the
     hero's size, then the last size tapped in the hero or in "Choose your bottle." (a sold-out default stays hidden until a
     tap); collections = the card whose Add to cart was tapped or the size picked in the bar's menu; with no pick, the product
     opened last this session if it is on the page, else the 3 g, else the lowest-priced product on the page.
   - Each product has its own form and wallet button. The wallet markup waits in a <template> and is created the first time the
     bar shows that product, then Shopify.PaymentButton.init() is called. Add to cart is a normal /cart/add form: luxe-ui.js
     adds it and opens the cart drawer.
   - Homepage and collections: the bar is moved to the end of the section that printed it (out of the transformed hero wrap,
     before the next section and the footer in the Tab order). The collection size menu sits at the start of the bar and never moves, so focus stays
     on it after a pick; bottles are listed by weight, the bundles after them; it is as wide as its text, and the weight part of
     a bundle label (the 7 g of the Gift Box) is dropped when the full text does not fit. From 990 px a collection bar lines up
     with its grid.
   Fix round (2026-10-15, after the verification): the menu no longer moves (focus kept), placement at the end of the section, the
   sold-out homepage default, focus back on Add to cart also when the drawer closes within the 1.2 s "Added" state, a
   re-rendered section's old bar is removed by key, grid alignment.
   Hidden bar: data-visible="false", aria-hidden="true", inert (never focusable). One IIFE, no dependencies. */
(function () {
  'use strict';
  if (window.__rsbBoot) { window.__rsbBoot(); return; }
  var html = document.documentElement;
  var bars = [];
  var ctx2d = null;

  function q(sel, ctx) { if (!sel) return null; try { return (ctx || document).querySelector(sel); } catch (e) { return null; } }
  function qa(sel, ctx) { if (!sel) return []; try { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); } catch (e) { return []; } }
  function rendered(el) { return !!el && el.getClientRects().length > 0; }
  function firstRendered(sel) { var list = qa(sel); for (var i = 0; i < list.length; i++) if (rendered(list[i])) return list[i]; return null; }
  function store(k, v) { try { if (v === undefined) return window.sessionStorage.getItem(k); window.sessionStorage.setItem(k, v); } catch (e) {} return null; }
  function fire(el) { try { el.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) {} }
  function initWallets() { try { if (window.Shopify && window.Shopify.PaymentButton && typeof window.Shopify.PaymentButton.init === 'function') window.Shopify.PaymentButton.init(); } catch (e) {} }
  function textWidth(el, text) {
    try {
      var cs = getComputedStyle(el);
      ctx2d = ctx2d || document.createElement('canvas').getContext('2d');
      ctx2d.font = cs.fontStyle + ' ' + cs.fontWeight + ' ' + cs.fontSize + ' ' + cs.fontFamily;
      return ctx2d.measureText(text || '').width;
    } catch (e) { return 0; }
  }
  // true when an ancestor would hold the fixed bar: position:fixed relative to it instead of the screen, or the bar's z-index
  // confined to its stacking context (later sections could then paint over the bar)
  function trapped(el) {
    for (var a = el.parentElement; a && a !== document.body && a !== html; a = a.parentElement) {
      var cs = getComputedStyle(a);
      if (cs.transform !== 'none' || cs.filter !== 'none' || cs.perspective !== 'none' || (cs.backdropFilter && cs.backdropFilter !== 'none') ||
          /transform|filter|perspective|opacity|z-index/.test(cs.willChange || '') || /paint|layout|strict|content/.test(cs.contain || '') ||
          (cs.containerType && cs.containerType !== 'normal') || (cs.contentVisibility && cs.contentVisibility !== 'visible') ||
          (cs.position !== 'static' && cs.zIndex !== 'auto') || parseFloat(cs.opacity) < 1 || cs.isolation === 'isolate' ||
          (cs.mixBlendMode && cs.mixBlendMode !== 'normal') || (cs.clipPath && cs.clipPath !== 'none') || (cs.maskImage && cs.maskImage !== 'none')) return true;
    }
    return false;
  }
  function syncShown() {
    var any = bars.some(function (b) { return b.shown && !b.dead; });
    html.classList.toggle('rsb-shown', any);
  }

  function Bar(root) {
    var self = this;
    this.root = root; this.shown = false; this.dead = false;
    this.key = root.getAttribute('data-rsb-key') || '';
    var mode = root.getAttribute('data-rsb-mode') || 'pdp';
    var items = qa('[data-rsb-item]', root);
    if (!items.length) return;
    this.home = root.closest('.shopify-section');   // the section that printed the bar (theme editor: re-rendered sections)
    if (root.hasAttribute('data-rsb-move')) {
      // the last child of that section: out of the transformed hero wrap, after the section's content and before the next
      // section and the footer in the Tab order (the sections stay adjacent, so the theme's section dividers are unchanged);
      // <body> when the section would hold a fixed element (see trapped)
      var host = self.home;
      if (host && root.parentNode !== host) host.appendChild(root);
      if (!host || trapped(root)) document.body.appendChild(root);
    }
    var cur = items.filter(function (it) { return !it.hidden; })[0] || null;
    var anchorEl = null;   // collections: the chosen card's buy area (null = the grid)
    var loaded = [];
    var walletPlan = root.getAttribute('data-wallet-plan') === 'true';
    var revealMode = root.getAttribute('data-reveal-mode') || 'after_button';
    var revealAfter = parseInt(root.getAttribute('data-reveal-after'), 10) || 240;
    var sel = null, pick = null, lastBtn = null, tapped = false;
    var box = root.querySelector('.rsb__items');

    function byVariant(id) { id = String(id || ''); for (var i = 0; i < items.length; i++) if (items[i].getAttribute('data-variant') === id) return items[i]; return null; }
    function byHandle(h) { for (var i = 0; i < items.length; i++) if (items[i].getAttribute('data-handle') === h) return items[i]; return null; }
    function available(it) { return it.getAttribute('data-available') === 'true'; }
    function cardBuyFor(it) {
      var id = it.getAttribute('data-variant'), forms = qa('form.product-card__form, form.rdr-shop__form');
      for (var i = 0; i < forms.length; i++) {
        var inp = forms[i].querySelector('input[name="id"]');
        if (inp && inp.value === id) return forms[i].closest('.product-card__buy, .rdr-shop__buy') || forms[i];
      }
      return null;
    }

    function loadWallet(it) {
      if (!it || loaded.indexOf(it) !== -1) return;
      loaded.push(it);
      var slot = it.querySelector('[data-rsb-wallet]'), tpl = slot && slot.querySelector('template[data-rsb-wallet-tpl]');
      if (!tpl) return;
      slot.appendChild(tpl.content.cloneNode(true));
      tpl.parentNode.removeChild(tpl);
      initWallets();
    }

    function show(on) {
      on = !!on;
      if (on === self.shown && root.getAttribute('data-visible') === String(on)) return;
      self.shown = on;
      root.setAttribute('data-visible', on ? 'true' : 'false');
      root.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (on) root.removeAttribute('inert'); else root.setAttribute('inert', '');
      syncShown();
    }

    function contextWant() {
      if (mode === 'pdp') {
        var form = q(root.getAttribute('data-rsb-anchor')) || q(root.getAttribute('data-rsb-fallback'));
        if (form && revealMode !== 'off_screen') return (form.querySelector('button[type="submit"]') || form).getBoundingClientRect().bottom < 0;
        if (form) { var fr = form.getBoundingClientRect(); return fr.top > window.innerHeight || fr.bottom < 0; }
        return (window.scrollY || window.pageYOffset) > revealAfter;
      }
      var a = (anchorEl && rendered(anchorEl)) ? anchorEl : (firstRendered(root.getAttribute('data-rsb-anchor')) || firstRendered(root.getAttribute('data-rsb-fallback')));
      if (!a || a.getBoundingClientRect().bottom >= 0) return false;
      var own = qa(root.getAttribute('data-rsb-own'));
      for (var i = 0; i < own.length; i++) {
        if (!rendered(own[i])) continue;
        var r = own[i].getBoundingClientRect();
        if (r.bottom > 0 && r.top < window.innerHeight) return false;
      }
      return true;
    }
    function footerOnScreen() {
      var f = q('footer.footer');
      return !!f && rendered(f) && f.getBoundingClientRect().top < window.innerHeight;
    }
    function update() {
      if (self.dead) return;
      // homepage: a sold-out default (no tap yet) is not advertised; a tapped sold-out size still shows "Sold out"
      var want = !!cur && (mode !== 'home' || tapped || available(cur)) && contextWant() && !footerOnScreen();
      // Focus hold: a shopper using the bar (keyboard, or the size menu) keeps it until focus leaves it.
      if (!want && self.shown && root.contains(document.activeElement) && document.activeElement !== document.body) want = true;
      show(want);
      if (want) loadWallet(cur);
      html.style.setProperty('--rsb-h', root.offsetHeight + 'px');
    }
    this.update = update;

    // ---------- collections from 990 px: the bar's content lines up with the grid's edges ----------
    function align() {
      if (mode !== 'collection') return;
      var g = firstRendered(root.getAttribute('data-rsb-fallback'));
      if (!g || window.innerWidth < 990) { root.style.paddingLeft = ''; root.style.paddingRight = ''; return; }
      var r = g.getBoundingClientRect(), vw = html.clientWidth;
      root.style.paddingLeft = Math.max(32, Math.round(r.left)) + 'px';
      root.style.paddingRight = Math.max(32, Math.round(vw - r.right)) + 'px';
    }

    // ---------- the size menu (collections): fixed place, its own width, full or short labels ----------
    function pickRoom() {
      var cs = getComputedStyle(box), gap = parseFloat(cs.columnGap) || 0;
      var w = box.clientWidth - (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.paddingRight) || 0);
      if (!cur) return w;
      [cur.querySelector('.rsb__media'), cur.querySelector('.rsb__info'), cur.querySelector('.rsb__form')].forEach(function (el) {
        if (!el || !rendered(el) || getComputedStyle(el).position === 'absolute') return;
        if (el.classList.contains('rsb__info')) { var p = el.querySelector('.rsb__price'); w -= (p ? Math.ceil(textWidth(p, p.textContent)) : 0) + gap; }
        else w -= el.getBoundingClientRect().width + gap;
      });
      return w;
    }
    function fitPicker() {
      if (!sel) return;
      var cs = getComputedStyle(sel), pad = (parseFloat(cs.paddingLeft) || 0) + (parseFloat(cs.paddingRight) || 0) + 2;
      var room = pickRoom(), longest = 0, opts = Array.prototype.slice.call(sel.options);
      opts.forEach(function (o) { longest = Math.max(longest, textWidth(sel, o.getAttribute('data-full'))); });
      var useShort = room > 0 && longest + pad > room;
      opts.forEach(function (o) { var t = o.getAttribute(useShort ? 'data-short' : 'data-full'); if (o.textContent !== t) o.textContent = t; });
      var o = sel.options[sel.selectedIndex];
      if (o) sel.style.width = Math.ceil(textWidth(sel, o.textContent) + pad) + 'px';
    }
    function placePicker() {
      if (!sel || !cur) return;
      sel.value = cur.getAttribute('data-variant');
      var lab = cur.querySelector('.rsb__label');
      if (lab && lab.id) sel.setAttribute('aria-describedby', lab.id);
      fitPicker();
    }
    function setCurrent(it) {
      if (!it || it === cur) return;
      if (cur) cur.hidden = true;
      it.hidden = false;
      cur = it;
      placePicker();
    }
    function select(id, source, anchor) {
      if (self.dead) return false;
      var it = byVariant(id);
      if (!it) return false;
      if (mode === 'collection' && !available(it)) return false;
      setCurrent(it);
      if (mode === 'collection' && anchor) anchorEl = anchor;
      if (self.shown) loadWallet(it);
      update();
      return true;
    }
    this.select = select;

    // ---------- defaults ----------
    if (mode === 'home') {
      var d = q(root.getAttribute('data-rsb-default-from'));
      if (d && byVariant(d.value)) setCurrent(byVariant(d.value));
    }
    if (mode === 'collection') {
      var last = store('rsb:last'), it = last ? byHandle(last) : null;
      if (it && available(it)) { setCurrent(it); anchorEl = cardBuyFor(it); }
      else {
        it = items.filter(function (x) { return x.getAttribute('data-grams') === '3' && available(x); })[0];
        if (!it) {
          items.forEach(function (x) {
            if (!available(x)) return;
            if (!it || Number(x.getAttribute('data-price')) < Number(it.getAttribute('data-price'))) it = x;
          });
        }
        if (it) setCurrent(it);
      }
    }
    if (mode === 'pdp' && cur) store('rsb:last', cur.getAttribute('data-handle'));

    // ---------- the size menu (collections) ----------
    if (root.hasAttribute('data-rsb-picker') && box) {
      var avail = items.filter(available);
      if (avail.length > 1) {
        // bottles by weight, then the bundles (and anything without a weight) in grid order
        var sized = avail.filter(function (x) { return !x.hasAttribute('data-bundle') && Number(x.getAttribute('data-grams')) > 0; });
        sized = sized.map(function (x, i) { return [x, i]; }).sort(function (a, b) { return (Number(a[0].getAttribute('data-grams')) - Number(b[0].getAttribute('data-grams'))) || (a[1] - b[1]); }).map(function (p) { return p[0]; });
        var rest = avail.filter(function (x) { return sized.indexOf(x) === -1; });
        pick = document.createElement('label');
        var vh = document.createElement('span');
        pick.className = 'rsb__pick'; vh.className = 'rsb__vh'; vh.textContent = 'Choose a product';
        sel = document.createElement('select');
        sized.concat(rest).forEach(function (x) {
          var o = document.createElement('option'), full = x.getAttribute('data-label') || '';
          o.value = x.getAttribute('data-variant');
          o.setAttribute('data-full', full); o.setAttribute('data-short', full.split(' \u00b7 ')[0]);
          o.textContent = full;
          sel.appendChild(o);
        });
        pick.appendChild(vh); pick.appendChild(sel);
        box.insertBefore(pick, box.firstChild);
        sel.addEventListener('change', function () { select(sel.value, 'menu', null); });
        placePicker();
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitPicker);
      } else root.removeAttribute('data-rsb-picker');
    }

    // ---------- what selects a product ----------
    document.addEventListener('rsb:select', function (e) {
      var dt = e.detail || {};
      if (mode === 'pdp') return;
      if (byVariant(dt.variant)) tapped = true;
      select(dt.variant, dt.source || 'event', null);
    });
    if (mode === 'collection') {
      document.addEventListener('submit', function (e) {
        var f = e.target;
        if (!f || !f.matches || !f.matches('.product-card__form, .rdr-shop__form') || root.contains(f)) return;
        var inp = f.querySelector('input[name="id"]');
        if (inp) select(inp.value, 'card', f.closest('.product-card__buy, .rdr-shop__buy') || f);
      }, true);   // capture: runs before luxe-ui.js adds the item; never prevents it
    }

    // ---------- product page: the bar follows the main form ----------
    if (mode === 'pdp' && cur) {
      var mainForm = q(root.getAttribute('data-rsb-anchor')) || q(root.getAttribute('data-rsb-fallback'));
      var barForm = cur.querySelector('form');
      var pr = cur.querySelector('[data-psat-price]'), planLbl = cur.querySelector('[data-psat-plan]'), basePrice = pr ? pr.textContent : '';
      var qtyBar = cur.querySelector('[data-rsb-qty-input]'), qtyLbl = cur.querySelector('[data-rsb-qty]');
      var planIn = cur.querySelector('[data-rsb-plan]'), slot = cur.querySelector('[data-rsb-wallet]');
      var idIn = barForm ? barForm.querySelector('input[name="id"]') : null;
      var plan = function () {
        if (!mainForm) return '';
        var r = mainForm.querySelector('[data-po-radio]:checked'), fs = mainForm.querySelector('[data-po-frequency-select]');
        if (r && r.value === 'subscribe' && fs && fs.value) return fs.value;
        var h = mainForm.querySelector('[data-selling-plan-input]');
        return (r && r.value === 'subscribe' && h && h.value) ? h.value : '';
      };
      var syncPlan = function () {
        if (!mainForm) return;
        var r = mainForm.querySelector('[data-po-radio]:checked'), fs = mainForm.querySelector('[data-po-frequency-select]');
        var sub = !!(r && r.value === 'subscribe'), o = sub && fs && fs.selectedIndex >= 0 ? fs.options[fs.selectedIndex] : null;
        if (pr) pr.textContent = sub && o && o.getAttribute('data-plan-price') ? o.getAttribute('data-plan-price') : basePrice;
        if (planLbl) planLbl.hidden = !sub;
        var v = plan();
        if (slot) slot.hidden = !!(v && !walletPlan);
        if (planIn) {
          if (v && walletPlan) { if (planIn.disabled || planIn.value !== v) { planIn.disabled = false; planIn.value = v; fire(planIn); } }
          else if (!planIn.disabled || planIn.value) { planIn.value = ''; planIn.disabled = true; fire(planIn); }
        }
      };
      var qtyMain = mainForm ? mainForm.querySelector('input[name="quantity"]') : null;
      var syncQty = function () {
        if (!qtyBar || !qtyMain) return;
        var n = parseInt(qtyMain.value, 10); n = n > 0 ? n : 1;
        if (qtyBar.value !== String(n)) { qtyBar.value = String(n); fire(qtyBar); }
        if (qtyLbl) { qtyLbl.textContent = n > 1 ? ' \u00d7 ' + n : ''; qtyLbl.hidden = n < 2; }
      };
      if (mainForm) {
        mainForm.addEventListener('change', function (e) { var t = e.target; if (t && t.matches && t.matches('[data-po-radio], [data-po-frequency-select]')) syncPlan(); if (t === qtyMain) syncQty(); });
        mainForm.addEventListener('click', function (e) { if (e.target && e.target.closest && e.target.closest('[data-qty-minus],[data-qty-plus]')) setTimeout(syncQty, 0); });
        if (qtyMain) qtyMain.addEventListener('input', syncQty);
      }
      document.addEventListener('variant:changed', function (e) {
        var dt = e.detail || {};
        if (dt.id && idIn && idIn.value !== String(dt.id)) { idIn.value = dt.id; cur.setAttribute('data-variant', String(dt.id)); fire(idIn); }
        if (dt.priceFormatted) basePrice = dt.priceFormatted;
        syncPlan();
      });
      if (barForm && planIn) {
        // Subscribe & save on the bar's Add to cart: the plan rides on this submit only (luxe-ui.js reads the form in the same
        // event), then the input is disabled again, so Shopify's wallet consent only ever sees the main form's plan.
        barForm.addEventListener('submit', function () {
          var v = plan();
          if (!v || walletPlan) return;
          planIn.disabled = false; planIn.value = v;
          setTimeout(function () { if (!walletPlan) { planIn.value = ''; planIn.disabled = true; } }, 0);
        }, true);
      }
      syncPlan(); syncQty();
    }

    // ---------- focus back on the bar's Add to cart when the cart drawer closes ----------
    root.addEventListener('submit', function (e) { lastBtn = e.target && e.target.querySelector ? e.target.querySelector('button[type="submit"]') : null; }, true);
    if (window.MutationObserver) {
      var locked = html.classList.contains('luxe-lock');
      new MutationObserver(function () {
        var now = html.classList.contains('luxe-lock');
        if (locked && !now && lastBtn) {
          var b = lastBtn; lastBtn = null;
          // the bar slides back over .45 s and luxe-ui keeps the button disabled ("Added") for 1.2 s after an add, so focus is
          // tried every 50 ms for up to 2 s; it stops as soon as the shopper has put focus somewhere else
          var tries = 0, back = function () {
            var a = document.activeElement;
            if (self.dead || !self.shown || !root.contains(b) || !(!a || a === document.body || a === html || a === b || (a.closest && a.closest('.cdrawer')))) return;
            if (!b.disabled && a !== b) { try { b.focus({ preventScroll: true }); } catch (x) {} }
            if (document.activeElement !== b && ++tries < 40) setTimeout(back, 50);
          };
          setTimeout(back, 0);
        }
        locked = now;
      }).observe(html, { attributes: true, attributeFilter: ['class'] });
    }

    var ticking = false;
    function onScroll() { if (!ticking) { ticking = true; window.requestAnimationFrame(function () { ticking = false; update(); }); } }
    function onResize() { align(); fitPicker(); onScroll(); }
    document.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);
    window.addEventListener('pageshow', onScroll);
    root.addEventListener('focusout', function () { setTimeout(update, 0); });
    if (window.ResizeObserver) new ResizeObserver(function () { if (!self.dead) html.style.setProperty('--rsb-h', root.offsetHeight + 'px'); }).observe(root);
    bars.push(this);
    align();
    update();
  }

  function remove(b) { b.dead = true; if (b.root.parentNode) b.root.parentNode.removeChild(b.root); }
  function boot() {
    // theme editor: a re-rendered section prints a new bar; the moved copy of the old one goes
    bars = bars.filter(function (b) { if (b.home && !b.home.isConnected) { remove(b); return false; } return true; });
    qa('[data-rsb]').forEach(function (root) {
      if (root.__rsb) return;
      root.__rsb = true;
      var key = root.getAttribute('data-rsb-key') || '';
      bars = bars.filter(function (b) { if (b.key === key && b.root !== root) { remove(b); return false; } return true; });
      new Bar(root);
    });
    syncShown();
  }
  window.__rsbBoot = boot;
  boot();
  document.addEventListener('shopify:section:load', boot);
})();
